export default "__VITE_ASSET__BpQTVd6q__"